// extracted by mini-css-extract-plugin
export default {"sheetHeader":"DashboardSheetHeader_sheetHeader__NOnAg","title":"DashboardSheetHeader_title__65FvG","skeletonLoadingAnimation":"DashboardSheetHeader_skeletonLoadingAnimation__jwn3t"};